import * as React from 'react'
import LiveSimulationsSection from 'components/simulation/components/live-simulations-sections'
import ProposedSimulationSection from '../proposed-simulations-section'
import IncomingSimulationSection from '../incoming-simulations-section'
import SuspendedSimulationsSection from '../suspended-simulations-section'
import CardCreateQuiz from 'components/shared/card-create-quiz'
import { useAppConfig } from 'hooks/features/use-features'
import useTranslation from 'next-translate/useTranslation'
import { useBanners } from 'hooks/swr'
import { UserContext } from 'providers//context/user-context'
import Banner from 'components/shared/banner'

const ExercisePage = (props: Exercise) => {
    const { appConfig } = useAppConfig()
    const { t } = useTranslation('simulation')

    const { userData } = React.useContext(UserContext)
    const banners = useBanners(userData?.workspaceId || '')

    const simulationBanner = React.useMemo(
        () => banners.data?.find((el) => el.page === 'SIMULATION' && el.type === 'IMAGE'),
        [banners.data],
    )
    const cardAdaptFlex = React.useMemo(() => (simulationBanner?.image ? 0.75 : 1), [simulationBanner?.image])
    const bannerAdaptFlex = React.useMemo(() => (simulationBanner?.image ? 0.25 : 1), [simulationBanner?.image])

    return (
        <div>
            <LiveSimulationsSection liveSimulations={props.liveSimulations || []} />

            {appConfig.feature.includes('customSimulation') ? (
                <div className="mb-8 flex flex-col md:flex-row gap-2">
                    <div style={{ flex: cardAdaptFlex }}>
                        <CardCreateQuiz
                            title={t('customSimCard.title')}
                            description={t('customSimCard.description')}
                            btnTxt={t('customSimCard.btn')}
                        />
                    </div>
                    {simulationBanner?.image ? (
                        <div style={{ flex: bannerAdaptFlex, position: 'relative', maxWidth: '100%' }}>
                            <Banner bannerData={simulationBanner} />
                        </div>
                    ) : null}
                </div>
            ) : null}

            <ProposedSimulationSection
                loading={props.loading && props.userSimLoading}
                simulations={props.simulations?.slice(0, 3)}
                setIndexTab={props.setIndexTab}
            />
            <IncomingSimulationSection
                loading={props.loading && props.userSimLoading}
                incomingAndLiveSimulations={props.incomingAndLiveSimulations?.slice(0, 3)}
                setIndexTab={props.setIndexTab}
            />
            <SuspendedSimulationsSection
                loading={props.loading && props.userSimLoading}
                suspendedSimulations={props.suspendedSimulations?.slice(0, 3)}
                setIndexTab={props.setIndexTab}
            />
        </div>
    )
}

export default ExercisePage
